import gql from "graphql-tag";

export const resetProjectOnboarding = gql`
  mutation ResetProjectOnboarding($projectId: String) {
    ResetProjectOnboarding(input: { projectId: $projectId }) {
      success
    }
  }
`;
